import not_found from 'assets/images/common/not_found.jpeg'
// import OrderStatusEnum from "Enums/OrderStatusEnum"
import _ from "lodash"

export const displayMedia = (src) => src || not_found

export const API_BASE_URL_ENV = () => {
    // return 'http://localhost:8000/api';
    return 'https://meras.pencilserver.com/api'
}

export const GET_AUTH_USER = () => JSON.parse(localStorage.getItem('auth'))

export const handleFieldChange = (e, setFormData, formData) => {
    setFormData({...formData, ...{[e.target.name]: e.target.value}})
}

export const handleSelectChange = (option, fieldName, setFormData, formData, cbFunc = {}) => {
    const optionValues = Array.isArray(option) ? option.map(({value}) => value) : option ? option.value : null
    setFormData({...formData, ...{[fieldName]: optionValues}})
    if (!_.isEmpty({cbFunc}))
        cbFunc[fieldName]
}

// export const getOrderColor = (status) => {
//     switch (status) {
//         case OrderStatusEnum.PENDING.value:
//             return OrderStatusEnum.PENDING.className;
//         case OrderStatusEnum.APPROVED.value:
//             return OrderStatusEnum.APPROVED.className;
//         case OrderStatusEnum.CANCELED.value:
//             return OrderStatusEnum.CANCELED.className;
//         case OrderStatusEnum.DELIVERED.value:
//             return OrderStatusEnum.DELIVERED.className;
//         case OrderStatusEnum.REJECTED.value:
//             return OrderStatusEnum.REJECTED.className;
//         default:
//             return 'btnDone';
//     }
// }

// export const getBackgroundOrderColor = (status) => {
//     switch (status) {
//         case OrderStatusEnum.PENDING.value:
//             return 'bg-info';
//         case OrderStatusEnum.APPROVED.value:
//             return 'bg-success';
//         case OrderStatusEnum.CANCELED.value:
//             return 'bg-danger';
//         case OrderStatusEnum.DELIVERED.value:
//             return 'bg-warning';
//         case OrderStatusEnum.REJECTED.value:
//             return 'bg-danger';
//         default:
//             return 'bg-info';
//     }
// }


export const getLang = () => {
    return localStorage.getItem('meras_lang');
}

export const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}


